<table class="table">
  <thead>
    <tr>
      @for (header of headers; track header) {
        <th>
          @if (header.sortable) {
            <span appSortable="{{ header.name }}" (sort)="onSort($event)">{{ header.title }}</span>
          }
          @if (!header.sortable) {
            <span>{{ header.title }}</span>
          }
        </th>
      }
    </tr>
  </thead>
  <tbody>
    <ng-content></ng-content>
  </tbody>
</table>
